export const RoleTypes = {
  USER: "user",
  CREATOR: "creator",
};
